import {
  Link,
  useHistory,
  useRouteMatch,
} from 'react-router-dom/cjs/react-router-dom.min';
import { logOut, openSideNav, registerRoutes } from '../../../func';
import { useCallback, useEffect, useMemo, useState } from 'react';
import GeneralTab from './generalTab';
import AddressTab from './addressTab';
import { useDispatch } from 'react-redux';
import Axios from 'axios';

const CreateBuyingGroup = () => {
  const history = useHistory();
  const { path } = useRouteMatch();
  const dispatch = useDispatch();
  const authData = useMemo(
    () => JSON.parse(localStorage.getItem('auth_data')),
    []
  );

  const initGeneralValues = () => ({
    name: '',
    phone: '',
    email: '',
    website: '',
  });

  const initAddressValeus = () => ({
    addressLineOne: '',
    addressLineTwo: '',
    city: '',
    stateId: 0,
    zip: '',
  });

  const [tab, setTab] = useState('general');
  const [generalValues, setGeneralValues] = useState(initGeneralValues());
  const [addressValues, setAddressValues] = useState(initAddressValeus());
  const [stateList, setStateList] = useState([]);

  const networkCalls = useMemo(
    () =>
      registerRoutes(
        {
          getStateList: {
            func: () => {
              Axios.get('/api/v1/state/read/all', {
                params: authData,
              })
                .then(result => setStateList(result.data))
                .catch(logOut);
            },
            type: 'r',
          },
          createBuyingGroup: {
            func: values => {
              Axios.post('/api/v2/buyinggroup/create/one/buyinggroup', {
                ...authData,
                ...values,
                name: values.name.trim()
              })
                .then(result => {
                  dispatch(result.data);
                  history.push('/buyinggroup');
                })
                .catch(logOut);
            },
            type: 'c',
          },
        },
        path
      ),
    [path, dispatch, authData]
  );

  useEffect(() => {
    networkCalls.getStateList();
  }, []);

  const submit = useCallback(() => {
    networkCalls.createBuyingGroup({
      ...generalValues,
      ...addressValues,
    });
  }, [generalValues, addressValues, networkCalls]);

  const getContent = useCallback(() => {
    switch (tab) {
      case 'general':
        return (
          <GeneralTab
            values={generalValues}
            setValues={setGeneralValues}
            next={() => setTab('address')}
            reset={() => setGeneralValues(initGeneralValues())}
          />
        );
      case 'address':
        return (
          <AddressTab
            values={addressValues}
            setValues={setAddressValues}
            back={() => setTab('general')}
            reset={() => setAddressValues(initAddressValeus())}
            save={submit}
            stateList={stateList}
          />
        );
      default:
        return null;
    }
  }, [
    tab,
    generalValues,
    setGeneralValues,
    addressValues,
    setAddressValues,
    stateList,
    submit,
  ]);

  return (
    <div className="main">
      <div className="row">
        <div style={{ display: 'flex' }}>
          <Link to="/" onClick={openSideNav} style={{ marginRight: '12px' }}>
            <i className="material-icons black-text">menu</i>
          </Link>
          <Link to="/">Home</Link>
          <i className="material-icons">chevron_right</i>
          <Link to="/buyinggroup">Buying Groups</Link>
          <i className="material-icons">chevron_right</i>
          <span className="grey-text">Create Buying Group</span>
        </div>
      </div>
      <div className="row">
        <h5 className="center">New Buying Group</h5>
      </div>
      <div className="row">
        <div className="col s4 m3 l2">
          <ul className="collection">
            <li
              id="tab-general"
              className={`collection-item ${tab === 'general' ? 'blue white-text' : ''}`}
              onClick={() => setTab('general')}
              style={{ cursor: 'pointer' }}
            >
              General
            </li>
            <li
              id="tab-address"
              className={`collection-item ${tab === 'address' ? 'blue white-text' : ''}`}
              onClick={() => setTab('address')}
              style={{ cursor: 'pointer' }}
            >
              Address
            </li>
          </ul>
        </div>
        <div className="col s8 m9 l10">{getContent()}</div>
      </div>
    </div>
  );
};

export default CreateBuyingGroup;
